import React from 'react';
import { Button } from 'antd';
import { Icon } from '@common/components';
import { capitalize } from 'lodash';

export const FilterButton = ({
  keyName,
  value,
  clearFilter,
  labelName,
}: {
  keyName: string;
  value: string;
  clearFilter: (key: string, name: string) => void;
  labelName: string;
}) => (
  <Button
    onClick={() => clearFilter(keyName, value)}
    key={`${keyName}-${value}`}
  >
    <Icon icon="xMark" kind="light" />
    {labelName || capitalize(value.toString().replace(/_/g, ' '))}
  </Button>
);
